<template>
  <div class="wrapper">
    <div class="header">
      <a-page-header
          :sub-title="accName"
      >
        <template #title>
          账户详情
        </template>
      </a-page-header>
    </div>
    <div class="body">

      <a-descriptions v-if="accNo" :column="1" bordered size="small">
        <a-descriptions-item label="户名">{{ accName }}</a-descriptions-item>
        <a-descriptions-item label="账号">
          <span  @click="copyAccountInfo">
          {{ accNo }} <a-icon type="copy"></a-icon>
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="开户银行">{{ bank }}</a-descriptions-item>
      </a-descriptions>

      <!-- 提示文案 -->
      <div class="tip-text" v-if="accNo">
        <p> <a-icon type="bulb" theme="twoTone" />提示：</p>
        <p>1. 请使用{{ accName }}的【本人同名账户】向以上账号转账充值</p>
        <p>2. 请妥善保管上述账户信息，如若遗失可联系核心企业客服找回</p>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
      accNo: "",
      accName: "",
      bank: "",
    };
  },
  mounted() {
    this.parseBusiParam();
  },
  methods: {
    /**
     * 解析 URL 参数中的 invite_code
     */
    async parseBusiParam() {
      const params = new URLSearchParams(window.location.search);
      this.accNo = params.get("accNo");
      this.accName = params.get("accName");
      this.bank = params.get("bank");
    },
    async copyAccountInfo() {
      const textToCopy = `${this.accNo}`;
      try {
        await navigator.clipboard.writeText(textToCopy);
        this.$message.success('已复制');
      } catch (err) {
      }
    }
  },
};
</script>

<style lang="less">
.wrapper {
  font-size: 16px;
  padding: 0;
}

.header {
  .ant-page-header {
    background-color: #57c6f477;
    color: #fff;
    border-bottom: none;

    .ant-page-header-heading {
      background: url('@/assets/img/czcb-logo.png') no-repeat right center ;
      background-size: contain;
      .ant-page-header-title,
      .ant-page-header-subtitle {
        color: #fff;
      }
    }
  }
}

.body {
  padding: 16px 20px;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-descriptions {
    font-size: 15px;
    padding-bottom: 16px;

    .ant-descriptions-item-label {
      font-weight: 600;
      color: #333;
    }

    .ant-descriptions-item-content {
      color: #666;
    }
  }

  .tip-text {
    font-size: 14px;
    color: #555;
    margin-top: 16px;
  }
}

.no-data {
  padding: 20px;
  text-align: center;
  color: #999;
}
</style>
